import { useEffect, useState } from "react";
import { Download, FileText, Copy, Check, QrCode } from "lucide-react";
import api, { API } from "@/lib/api";
import { toast } from "sonner";

const templates = [
  { key: "a5", label: "Présentoir A5", desc: "148 × 210 mm — accueil, comptoir" },
  { key: "card", label: "Carte de visite", desc: "85 × 55 mm" },
  { key: "flyer", label: "Flyer A6", desc: "105 × 148 mm" },
  { key: "square", label: "Carré réseaux sociaux", desc: "150 × 150 mm" },
];

export default function QRCodes() {
  const [settings, setSettings] = useState(null);
  const [copied, setCopied] = useState(false);
  const pngUrl = `${API}/qr/png`;

  useEffect(() => { api.get("/admin/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  const publicUrl = settings ? `${settings.public_url}/?ref=qr` : "";

  const copyLink = () => {
    navigator.clipboard.writeText(publicUrl);
    setCopied(true);
    toast.success("Lien copié");
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">QR codes</h1>
        <p className="text-[#64697a] mt-1">QR code permanent vers votre page d'avis CC Auto 30</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-[#161920] border border-[#262a33] rounded-xl p-6 flex flex-col items-center">
          <div className="bg-white rounded-2xl p-4">
            <img src={pngUrl} alt="QR code CC Auto 30" className="w-56 h-56 object-contain" data-testid="qr-preview" />
          </div>
          <div className="w-full mt-5 space-y-3">
            <div className="flex items-center gap-2 bg-[#0a0b0e] border border-[#262a33] rounded-xl px-3 py-2">
              <span className="text-xs text-[#a0a5b5] truncate flex-1" data-testid="qr-url">{publicUrl}</span>
              <button onClick={copyLink} data-testid="copy-qr-link" className="text-[#00e676]">{copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}</button>
            </div>
            <a href={pngUrl} download data-testid="download-png-btn" className="w-full flex items-center justify-center gap-2 bg-[#00e676] hover:bg-[#00c853] text-[#04120a] font-bold rounded-full py-3 transition-colors">
              <Download className="w-5 h-5" /> Télécharger PNG HD
            </a>
          </div>
        </div>

        <div className="space-y-3">
          <h3 className="font-semibold flex items-center gap-2"><QrCode className="w-5 h-5 text-[#00e676]" /> Modèles imprimables (PDF)</h3>
          {templates.map((t) => (
            <div key={t.key} className="bg-[#161920] border border-[#262a33] rounded-xl p-4 flex items-center justify-between gap-3">
              <div>
                <div className="font-semibold">{t.label}</div>
                <div className="text-xs text-[#64697a]">{t.desc}</div>
              </div>
              <a href={`${API}/qr/pdf/${t.key}`} target="_blank" rel="noopener noreferrer" data-testid={`download-pdf-${t.key}`}
                className="flex items-center gap-2 bg-[#2a2d35] hover:bg-[#363a45] text-white text-sm font-medium rounded-xl px-4 py-2 transition-colors whitespace-nowrap">
                <FileText className="w-4 h-4" /> PDF
              </a>
            </div>
          ))}
          <p className="text-xs text-[#64697a] pt-2">
            À utiliser sur : présentoir A5, comptoir, carte de visite, facture, flyer, document de restitution et affiche du garage.
          </p>
        </div>
      </div>
    </div>
  );
}
